import { useTracking } from '@zego/tracking';
import { getUtmMutationData } from '@zego/utils';

export default function useAttribution() {
  const {
    trackingContext: { featureName, locationName },
  } = useTracking();

  return {
    featureName,
    locationName,
    utmParams: getUtmMutationData(),
  };
}
